import Types from '../Types'

// Customer
const attemptFindHomeProducts = (payload = {}) => ({
  type: Types.FIND_HOME_PRODUCTS_ATTEMPT, payload
})

const attemptFindBestSellingProducts = (payload = {}) => ({
  type: Types.FIND_BEST_SELLING_PRODUCTS_ATTEMPT,
  payload: { ...payload, unitId: 1, recommended: true }
})

const attemptFindPromotionalProducts = (payload = {}) => ({
  type: Types.FIND_PROMOTIONAL_PRODUCTS_ATTEMPT,
  payload: { ...payload, unitId: 1, promotional: true }
})

const attemptFindGiveawayProducts = (payload = {}) => ({
  type: Types.FIND_GIVEAWAY_PRODUCTS_ATTEMPT,
  payload: { ...payload, unitId: 1, withGiveaway: true }
})

const attemptFindPrices = (payload = {}) => ({
  type: Types.FIND_PRICES_ATTEMPT, payload
})

const attemptFindProducts = (payload = {}) => ({
  type: Types.FIND_PRODUCTS_ATTEMPT, payload
})

const attemptAggregate = (payload = {}) => ({
  type: Types.AGGREGATE_PRODUCTS_ATTEMPT, payload
})

// Admin
const attemptFindAllProducts = (payload = {}) => ({
  type: Types.FIND_ALL_PRODUCTS_ATTEMPT, payload
})

const attemptFindOneProduct = (payload = {}) => ({
  type: Types.FIND_ONE_PRODUCT_ATTEMPT, payload
})

const attemptImportProducts = (file) => ({
  type: Types.IMPORT_PRODUCTS_ATTEMPT,
  payload: file
})

const attemptImportTags = (file) => ({
  type: Types.IMPORT_TAGS_ATTEMPT,
  payload: file
})

const attemptImportConfigs = (file) => ({
  type: Types.IMPORT_CONFIGS_ATTEMPT,
  payload: file
})

const attemptImportStocks = (file) => ({
  type: Types.IMPORT_STOCKS_ATTEMPT,
  payload: file
})

const attemptImportBackInStock = (file) => ({
  type: Types.IMPORT_BIS_ATTEMPT,
  payload: file
})

const attemptImportDeliveryCharge = (file) => ({
  type: Types.IMPORT_DC_ATTEMPT,
  payload: file
})

const attemptSaveProduct = (payload) => ({
  type: Types.SAVE_PRODUCT_ATTEMPT, payload
})

const attemptFindTags = () => ({
  type: Types.FIND_TAGS_ATTEMPT
})

const attemptFindProductRecommendations = (payload = {}) => ({
  type: Types.FIND_PRODUCT_RECOMMENDATIONS_ATTEMPT,
  payload
})

const attemptFindProductImages = (payload = {}) => ({
  type: Types.FIND_PRODUCT_IMAGES_ATTEMPT,
  payload
})

const attemptAddProductImage = (payload) => ({
  type: Types.ADD_PRODUCT_IMAGE_ATTEMPT,
  payload
})

const attemptRemoveProductImage = (payload = {}) => ({
  type: Types.REMOVE_PRODUCT_IMAGE_ATTEMPT,
  payload
})

const attemptFindBISProducts = (payload = {}) => ({
  type: Types.FIND_BIS_PRODUCTS_ATTEMPT,
  payload: { ...payload, unitId: 1, backInStock: true }
})

export default {
  attemptFindHomeProducts,
  attemptFindBestSellingProducts,
  attemptFindPromotionalProducts,
  attemptFindGiveawayProducts,
  attemptFindPrices,

  attemptFindProducts,
  attemptFindAllProducts,
  attemptFindOneProduct,
  attemptImportProducts,
  attemptImportTags,
  attemptImportConfigs,
  attemptImportStocks,
  attemptImportBackInStock,
  attemptImportDeliveryCharge,
  attemptSaveProduct,
  attemptFindTags,
  attemptFindProductRecommendations,
  attemptAggregate,

  attemptFindProductImages,
  attemptAddProductImage,
  attemptRemoveProductImage,

  attemptFindBISProducts
}



// WEBPACK FOOTER //
// ./src/redux/product/productActions.js